/* eslint-disable max-lines */
import store from '@/store';

export const config = {
    name: 'assetHandover',
    selection: false,
    index: true,
    searchFields: [
        {
            name: '部门',
            value: 'transferDeptCodeList',
            isFixed: true,
            type: 'select',
            filterable: true,
            multiple: true,
            options: [],
            span: 8
        },
        {
            name: '发起人',
            value: 'initiatorCode',
            isFixed: true,
            type: 'advanceUser',
            span: 4
        },
        {
            name: '流程发起时间',
            value: 'createTime',
            isFixed: true,
            type: 'time',
            time: 'daterange',
            startPlaceholder: '流程发起开始时间',
            endPlaceholder: '流程发起结束时间',
            span: 5
        },
        {
            name: '交接人',
            value: 'transferUserCode',
            isFixed: true,
            type: 'advanceUser',
            span: 4
        },
        {
            name: '状态',
            value: 'statusList',
            type: 'select',
            isFixed: true,
            multiple: true,
            optionNum: 'LCRM_MIP_STATUS',
            span: 4
        }
    ],
    columns: [
        {
            label: '交接人',
            prop: 'transferUserName',
            width: 240
        },

        {
            label: '所在部门',
            prop: 'transferDeptName',
            width: 240
        },
        {
            label: '发起人',
            prop: 'initiatorName',
            width: 120
        },
        {
            label: '发起时间',
            prop: 'submitTime',
            width: 240
        },
        {
            label: '状态',
            prop: 'status',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'LCRM_MIP_STATUS', // TODO
            width: 160
        }
    ],
    actions: {
        fixedWidth: 140,
        list: [
            {
                label: '查看',
                event: 'lookOpera'
            },
            {
                label: '编辑',
                event: 'editOpera',
                displayRule: (row) => {
                    if (row.status === 1 || row.status === 5 || row.status === 6) {
                        return true;
                    }
                    return false;
                }
            },
            {
                label: '删除',
                event: 'deleteOpera',
                displayRule: (row) => {
                    if (row.status === 1) {
                        return true;
                    }
                    return false;
                }
            }
        ]
    }
};
